// Import core styles
import 'filepond/dist/filepond.min.css';

// Import the plugin styles
import '../assets/contao_filepond_plugin.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.css';

import ContaoFilepond from './contao_filepond.js';

window.ContaoFilepond = ContaoFilepond;
